import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import AuthForm from '../../components/ui/forms/AuthForm';
import { Icon } from "@chakra-ui/react";
import { BsFillExclamationSquareFill } from 'react-icons/bs';
  
export default function Login() {
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    function handleSubmit() {
        setLoading(true);
        
        setTimeout(() => {
            setLoading(false)
            history.push("/dashboard/overview")
        }, 3000)
    }

    return (
        <div className="login-container">
            <Icon 
                as={BsFillExclamationSquareFill} 
                style={{ margin: '64px 160px 40px 160px' }} 
                size='lg' 
                color='rgb(107, 114, 128)' 
                marginRight={'2'} 
            />

            <AuthForm 
                isLoading={loading}
                onSubmit={handleSubmit} 
                formType='login' 
            />
        </div>
    )
}